module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_23",
      "title": "[Pg 23]"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "CHAPTER_III"
    }
  }, [_vm._v("CHAPTER III"), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    staticClass: "fs3"
  }, [_vm._v("WONDERFUL NEWS")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny Brown and his sister Sue made a\nrush for the hall to meet their father. In\nfact, they always ran to meet him as soon as\nthey heard him enter the house. But this time,\nbecause he called out that he had great news\nfor them, there was an extra reason for hurrying.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Don’t make too much noise, my dears,”\nsaid Mrs. Brown, motioning to the injured\nsailor.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“He doesn’t hear them,” said Uncle Tad,\nwho was sitting beside Mr. Pott. “He’s off\nin a stupor now. I’m afraid he’s going to be\na very sick man.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Too bad,” murmured Mrs. Brown. “If\nwe could only find his son and get word to\nhim about his father.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Likely the son will never be found,” replied\nUncle Tad in a low voice.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_24",
      "title": "[Pg 24]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Well, we’ll take care of this poor man\nuntil Dr. Rudd sees him again,” went on\nMrs. Brown. “By that time he may be better.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny and Sue found their father out in the\nhall. Generally they rushed at him with\nmerry peals of laughter and jolly shouts. But\nnow they had heard what their mother said\nabout disturbing Mr. Pott, so they were a little\nquieter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“What’s the great news, Daddy?” asked\nBunny.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Are we going away somewhere?” Sue\nwanted to know. To travel was the delight\nof the two children, and nothing pleased them\nso much as to be on the move—it did not much\nmatter where, as long as they were seeing\nsomething new. But probably most children\nare like that.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Yes, I think perhaps we are going away—on\nthe rolling ocean,” said Mr. Brown. “I’ll\ntell you more about it in a little while. But\nwhat is going on here? Some one told me\nthere had been an accident here, though I see\nit isn’t either of you two who is hurt. And it"), _c('span', {
    attrs: {
      "id": "Page_25",
      "title": "[Pg 25]"
    }
  }), _vm._v("\ncan’t be mother, for I hear her talking to\nUncle Tad.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“It’s Mr. Pott,” explained Bunny. “He’s\na sailor and he lost his son Harry and the\ntreasure and he was on a horse.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“But he fell off the horse,” quickly added\nSue. “And, Daddy, he ’most fell on us when\nwe played store!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“My! I should say that was a lot to have\nhappen to one,” said Mr. Brown. “Now\ndon’t make too much noise if we have a sick\nman in the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("He went into the room where his wife and\nUncle Tad were keeping watch over Mr. Pott,\nand from Mrs. Brown soon learned all there\nwas to know about the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Too bad,” said Mr. Brown. “Well, perhaps\nthings may turn out all right after all,\nbut it’s pretty hard for the old man to lose his\nson and a treasure at the same time.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Making the sailor as comfortable as possible,\nand leaving Uncle Tad to watch over him,\nMr. and Mrs. Brown and the children went\nto another room where they could talk together.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_26",
      "title": "[Pg 26]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“What’s this about some news the children\nsay you have?” asked Mrs. Brown.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“It is news, yes, in a way,” answered her\nhusband. “How would you like to take a\ntrip?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“It depends on where the trip is,” his wife\nsaid, with a smile. “If I had my choice I\nwould like to go down south where it is lovely\nand warm and where there are so many flowers\nand birds.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“You must have guessed what I was going\nto say,” laughed Mr. Brown, “for down south\nis where I was thinking of going.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Is it down to the sunny south where we\nwere once before?” asked Bunny. The Brown\nchildren had once taken a trip to the southland.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Not exactly the same place,” Mr. Brown\nreplied. “Of course, the south is always\nsunny, but this time I have in mind an ocean\nvoyage. I have to go to the West Indies on\nbusiness, and I have a chance to go on a\nsteamer which one of the big fish companies\nis sending. They have given me the use of\ntwo staterooms, so there will be room for all of"), _c('span', {
    attrs: {
      "id": "Page_27",
      "title": "[Pg 27]"
    }
  }), _vm._v("\nus. If you want to go and take the children,\nmy dear,” he said to his wife, “I think it\nwould be a pleasant trip for us all.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I don’t see how we could very well leave\nthem at home,” remarked Mrs. Brown, looking\nat Bunny and Sue.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Leave us at home? I guess not!” cried\nBunny. “I wouldn’t stay!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“And if Bunny doesn’t stay at home I’m not\ngoing to stay!” announced Sue, almost ready\nto cry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“There, now, don’t get excited,” laughed\nMr. Brown. “No one is going to be left at\nhome.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“And are we really going on the ocean?”\nasked Bunny.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“To get to the West Indies down near Cuba\nwe must go on the ocean,” answered Mr.\nBrown. “But though the ocean may roll a bit,\nit will not be very rough, if that’s what you’re\nthinking of.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Tell me more about it,” begged Mrs.\nBrown, while the children listened.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Well, it isn’t all settled yet,” Mr. Brown\nreplied. “But, as you know, I sell some of"), _c('span', {
    attrs: {
      "id": "Page_28",
      "title": "[Pg 28]"
    }
  }), _vm._v("\nmy fish to the Empire Sea Food Company of\nPhiladelphia. One of their men was in to see\nme the other day and told of an especial trip\none of their steamers was going to make to the\nWest Indies. They are to look up new places\nfrom which they may have southern fish\nshipped to them. This man said there would\nbe plenty of room on the "), _c('em', {
    staticClass: "calibre6"
  }, [_vm._v("Beacon")]), _vm._v(", which is the\nname of the steamer. She isn’t going to carry\nregular passengers, just the crew, some members\nof the fish company, and some of the\nwives of the officers of the company.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“So, as he offered me the use of two staterooms,\nwhich will be just enough for us, I\nthought perhaps you and the children might\nlike to go. I can leave my head clerk and\nBunker Blue in charge of my business here,\nand Uncle Tad can look after the house. So\nthere is no reason why we can’t all go on the\nrolling ocean.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I think I should love it,” said Mrs. Brown.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Are we going to-morrow?” Sue wanted to\nknow. “’Cause if we are, I’ve got to put a\nnew dress on my doll.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, no, we won’t go to-morrow!” laughed"), _c('span', {
    attrs: {
      "id": "Page_29",
      "title": "[Pg 29]"
    }
  }), _vm._v("\nher father. “Perhaps not for a week yet.\nYou’ll have plenty of time to dress Sallie Ann,\nif that’s the name of your doll.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“No,” said Sue, thinking the matter over,\n“I haven’t any doll named Sallie Ann. But,”\nshe added quickly, “if you would get me a new\ndoll I could name her Sallie Ann.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, ho, you little tyke! So that’s what\nyou’re thinking of, are you?” exclaimed Mr.\nBrown, catching Sue up in his arms. “Well,\nwe’ll see about the new doll later on. But if\nyou think it is settled about making the trip,\nI’ll send word to Captain Ward of the "), _c('em', {
    staticClass: "calibre6"
  }, [_vm._v("Beacon")]), _vm._v("\nso our staterooms will be made ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Yes, I think we’ll take the trip,” said Mrs.\nBrown.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Just then Sue called:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, look at Bunny! What’s he doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Well might she ask that, for Bunny was\nmoving about the room, reeling from side to\nside, heaving and rolling his shoulders and\nhead as though trying to turn himself inside\nout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Bunny! What’s the matter?” called his\nmother. “Are you ill?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_30",
      "title": "[Pg 30]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“No, I’m not sick!” replied Bunny, straightening\nup. “I’m just making believe I’m on a\nship on the rolling ocean. The ocean rolls,\ndaddy said, and I’m rolling. I’m on the rolling\nocean! The rolling ocean!” With a\nlaugh, Bunny again made his shoulders move\nin that funny way, imitating the heaving and\nswaying of a ship in the swell of the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“You’ll get plenty of that before we reach\nthe West Indies,” said Mr. Brown. “The\nocean will roll for you all you want it to.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I like the ocean,” announced the little boy.\n“I’m going to fish in it when we get on the\nsteamer.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“And maybe you’ll catch a crab and it will\npinch you,” said Sue.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I like crabs,” declared Bunny.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I don’t,” stated Sue. “I don’t like ’em\nalive! Once I got pinched by a crab.” This\nwas true. The children had gone out fishing\nin Sandport Bay with Bunker Blue once upon\na time. A crab had been caught and before\nSue could get out of the way of the queer,\nsidewise-moving creature, it had nipped her\non the leg.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_31",
      "title": "[Pg 31]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Well, since it is all settled that we are to\ngo on the rolling ocean,” announced Mr.\nBrown, “I’ll send word to Captain Ward. He\nasked me to let him know, and—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Hark!” suddenly exclaimed Mrs. Brown,\nholding up her hand for silence.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("A noise sounded in the other room where\nMr. Pott had been put. The voice of the\nsailor could be heard murmuring, and Uncle\nTad was answering him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I must see what’s the matter,” said Mrs.\nBrown.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0